import { defineStore } from 'pinia'
import api from '@/api'
import { weeklyStorage, sharedKeyPersist } from './persistence'
import { useMainStore } from './main'

export const useUserFlagsStore = defineStore('userFlags', {
	state: () => ({
		/**
		 * Remote user flags are stored in the backend. These flags are used to control state of user's profile.
		 * @type {Object}
		 */
		remote: {},
		/**
		 * Local user flags are stored in the frontend and synced with localStorage.
		 */
		local: {
			organicTrafficOnboarding: false,
			freebieAccess: false,

			isGdprPassed: false,

			cancellationFeeType: null,
			brazeAssessmentEmailSent: false,
			commitmentCancellationFlowPassed: false,

			applyDiscountOnAbort: false,

			scratchCardPassed: false,
			scratchCardDiscountApplied: false,

			/** DEV-33657: резолвнутый набор тегов need-matched-эксперимента, sticky на неделю (weeklyStorage). */
			needMatchedTagSet: null,
		},
	}),

	getters: {
		getFlags(state) {
			return {
				remote: state.remote,
				local: state.local,
			}
		},
		/**
		 * Check if any of the flags is greater than current time.
		 * This needs for checking if user has possibility to do some actions.
		 * @param {Array<string>|string} flags
		 * @returns {boolean}
		 */
		isAnyOfFlagsAfterCurrentTime: (state) => (flags) => {
			if (typeof flags === 'string') {
				flags = [flags]
			}

			for (const flag of flags) {
				const remoteFlag = state.remote[flag]

				if (Number.isInteger(remoteFlag) && remoteFlag > Date.now()) {
					return true
				}
			}

			return false
		},
		getIsOrganicTrafficOnboarding(state) {
			return state.local.organicTrafficOnboarding
		},
	},

	actions: {
		setRemoteFlags(flags) {
			this.remote = flags
		},
		updateLocalFlags(payload) {
			this.local = { ...this.local, ...payload }
		},

		async updateUserFlags(payload) {
			const mainStore = useMainStore()
			const flags = { ...this.remote, ...payload }

			await api.setUserFlags(flags)

			this.remote = flags

			if (mainStore.hasAlreadyExistedAccount) {
				api.mergeUserWithAlreadyExisted()
			}
		},
	},

	persist: sharedKeyPersist('vuex', 'userFlags', weeklyStorage),
})
